import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class ParentStore {
  parents = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      parents: observable,
      total: observable,
      loading: observable,
      loadData: action,
      deleteRecord: action,
      addData: action,
      getParent: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ searchField, companyId, classId }) {
    this.loading = true;

    var postData = {
      tokenId: "",
      companyId: companyId,
      offset: 0,
      limit: 50,
      searchField: searchField,
      classId: classId,
    };

    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("parent/getParentList", { params: postData });
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=parent&a=parentsdetails", "postData=" + base64Input);

    this.parents = response?.data?.data?.passdetails;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }
  async deleteRecord({ parentId }) {
    var postData = { parentId: parentId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .delete("parent/deleteParent", { params: postData });
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=parent&a=deleteParents", "postData=" + base64Input);
    return response;
  }
  async addData(parentData) {
    var postData = { AddParents: parentData };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=parent&a=update", "postData=" + base64Input);

    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("parent/addParent", { params: postData });
    return response?.data;
  }

  async getParent(parentId) {
    var postData = { parentId: parentId, offset: 0, limit: 1 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=parent&a=parentsdetails", "postData=" + base64Input);
    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("parent/getParentList", { params: postData });
    return response?.data?.data?.passdetails[0];
  }

  // async exportExcel(getData) {
  //   window.location.href =
  //     config.baseURL +
  //     "index.php?c=parent&a=parentsExportExcel&cid=" +
  //     getData.cid +
  //     "&colList=" +
  //     getData.colList +
  //     "&classId=" +
  //     getData.classId +
  //     "&searchField=" +
  //     getData.searchField;
  // }

  async exportExcel(postData) {
    var parentData = { postData };
    try {
      var response = await postApi
        .getClient("NodeCoreUrl")
        .post("parent/exportParentExcel", parentData, {
          responseType: "blob",
        });
      // console.log(response, "response");
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Parent_Export_Excel.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }
  // async exportPdf(getData) {
  //   window.location.href =
  //     config.baseURL +
  //     "index.php?c=parent&a=parentsExportPdf&cid=" +
  //     getData.cid +
  //     "&colList=" +
  //     getData.colList +
  //     "&classId=" +
  //     getData.classId +
  //     "&searchField=" +
  //     getData.searchField;
  // }
  async exportPdf(getData) {
    console.log(getData)
      try {
        var response = await postApi
          .getClient("NodeCoreUrl")
          .post("parent/exportPdf", getData, {
            responseType: "blob",
          });
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Parent list Report.pdf";
  
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading the file", error);
      }
    }
}

export default ParentStore;
